import React, { useEffect, useState, useContext } from "react";
import "../css/style.css";
import Footer from "./Footer";
import Navigation from "./NavigationPanel/Navigation";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import { RejectionResponseContext } from "../ContextApi";
import ModalError from "./Error-Span-Modal/ModalError";
import { FaIdCard, FaKey, FaRedoAlt, FaUnlockAlt, FaUserPlus } from "react-icons/fa";

const override = {
  display: "block",
  margin: "20% auto ",
  borderColor: "white",
};

// const loaderdiv ={
//   position: "absolute",
//   top: 0,
//   left: 0,
//   bottom: 50,
//   width: "100%",
//   height: "100%",
//  minHeight:"100%",
//   backgroundColor: "rgba(0, 0, 0, 0.6)",
//   backdropFilter: "blur(3px)",
//   zIndex: "15",
// }

function Login() {
  const isLoginpage = true;
  let navigate = useNavigate();
  const { t } = useTranslation();
  //Declearation of fields
  const [loginId, setLoginID] = useState("");
  const [password, setPassword] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [loadCaptcha, setLoadCaptcha] = useState(" ");
  const [styleCaptcha,setStyleCaptcha]=useState("");
  const [error, setError] = useState("");
  const [errorblock, setErrorBlock] = useState(false);
  const LoginKey = process.env.REACT_APP_LOGIN_SERVICE;

  const [isloading, setIsloading] = useState(false);

  const { setRejectionResponse } = useContext(RejectionResponseContext);

  useEffect(() => {
    captchaReload();
  }, []);

  const errorHandel = (e) => {
    setErrorBlock(true);
    // setTimeout(()=>{
    //   setErrorBlock(false)
    // },4000)
  };
  //function for reload captcha
  const captchaReload = () => {
    var alpha = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    var i;
    for (i = 0; i < 6; i++) {
      var a = alpha[Math.floor(Math.random() * alpha.length)];
      var b = alpha[Math.floor(Math.random() * alpha.length)];
      var c = alpha[Math.floor(Math.random() * alpha.length)];
      var d = alpha[Math.floor(Math.random() * alpha.length)];
      var e = alpha[Math.floor(Math.random() * alpha.length)];
      var f = alpha[Math.floor(Math.random() * alpha.length)];
    }
    var code = a + b + c + d + e + f;
    var styleCode=a+" "+b+" "+c+" "+d+" "+e+" "+f
    setLoadCaptcha(code);
    setStyleCaptcha(styleCode);
  };

  //Login handel function
  const loginHandel = (e) => {
    e.preventDefault();
    // const hashedPassword=bcrypt.hashSync(password, PasswordKey);

    const loginData = {
      userCode: loginId,
      password: password,
    };
 
    //comment this
    // setIsloading(true);
    // setTimeout(() => {
    //   setIsloading(false);
    //   navigate("/dashboard");
    // }, 2000);

    //login service implementation
    if (loginId === "" || password === "" || captcha === "") {
      setError("2d13aa4a4d1a2a0dedf1a03323d294b8");
      errorHandel(0);
    } else {
      if (loadCaptcha === captcha) {
        setIsloading(true);
        axios
          .post(`${LoginKey}/login/citizenLogin`, loginData)
          .then((response) => {
            setIsloading(false);
            // if (response.data.status == 1) {
            if (
              response.data.responseObject.citizenLoginResponse !== undefined
            ) {
              if (
                response.data.responseObject.citizenLoginResponse
                  .citizenLoginDetailsResponseData.result.status === 1
              ) {
                const accessToken = response.data.responseObject.accessToken;
                sessionStorage.setItem("accessToken", accessToken);
                const authToken = response.data.responseObject.authToken;
                sessionStorage.setItem("authToken", authToken);
                const refreshToken = response.data.responseObject.refreshToken;
                sessionStorage.setItem("refreshToken", refreshToken);
                const customerId =
                  response.data.responseObject.citizenLoginResponse
                    .citizenLoginDetailsResponseData.result.customerId;
                 sessionStorage.setItem("customerId", customerId);
                const userID =
                  response.data.responseObject.citizenLoginResponse
                    .citizenLoginDetailsResponseData.result.idCard;
                sessionStorage.setItem("userId", userID);
                navigate("/dashboard");
              } else if (
                response.data.responseObject.citizenLoginResponse
                  .citizenLoginDetailsResponseData.result.status === 0
              ) {
                setError("9cabed03d7bc7aa396bef73dab7fe030");
                errorHandel(0);
                captchaReload();
                e.target.reset();
                setLoginID("");
                setPassword("");
              } else if (
                response.data.responseObject.citizenLoginResponse
                  .citizenLoginDetailsResponseData.result.status === 2
              ) {
                captchaReload();
                setError("339234bc46cf4438261567e1eed8d393");
                errorHandel(0);
                setLoginID("");
                setPassword("");
                const accessToken = response.data.responseObject.accessToken;
                sessionStorage.setItem("accessToken", accessToken);
                const authToken = response.data.responseObject.authToken;
                sessionStorage.setItem("authToken", authToken);
                const refreshToken = response.data.responseObject.refreshToken;
                sessionStorage.setItem("refreshToken", refreshToken);
                const customerId =
                  response.data.responseObject.citizenLoginResponse
                    .citizenLoginDetailsResponseData.result.customerId;
                 sessionStorage.setItem("customerId", customerId);
                const userID =
                  response.data.responseObject.citizenLoginResponse
                    .citizenLoginDetailsResponseData.result.idCard;
                sessionStorage.setItem("userId", userID);
                const rejectRespone = {
                  idCard: loginId,
                  accessToken: response.data.responseObject.accessToken,
                  authToken:  response.data.responseObject.authToken
                };
                setRejectionResponse(rejectRespone);
                navigate("/rejectionApplication");
              } else if (
                response.data.responseObject.citizenLoginResponse
                  .citizenLoginDetailsResponseData.result.status === 3
              ) {
                captchaReload();
                setError("e140917ef195a4d3b75f79e90fd1a3eb");
                errorHandel(0);
                setLoginID("");
                setPassword("");
              }
            } else {
              captchaReload();
              setError("efa2ddab1adbb740ca25d353c13bf516");
              errorHandel(0);
            }
          })
          .catch((err) => {
            setIsloading(false);
            console.log(err);
            setError("4b2b25d11213a09ce090cda61c0ea175");
            errorHandel(0);
          });

        // fetch(`http://localhost:8765/owcs-login-service/login/citizenLogin`, {

        //   method: 'POST',
        //   body: JSON.stringify({
        //     // Add parameters here
        //     userCode:loginId,
        //   password:password,
        //   }),
        //   headers: {
        //     'Content-type': 'application/json; charset=UTF-8',
        //   },
        // })
        //    .then((response) => {
        //     if(response.responseObject.validationCode==1){
        //       setIsloading(false);
        //       navigate("/dashboard")
        //     }
        //    })

        //    .then((data) => {
        //       // Handle data

        //    })
        //    .catch((err) => {
        //    });
      } else {
        // setIsloading(false);
        captchaReload();
        setError("f27b4e981b3b196187360b4dfe856c47");
        errorHandel(0);
      }
    }

    // setLoginID("");
    // setPassword("");
  };
  const errorClose = (e) => {
    setErrorBlock(e);
  };
  return (
    <>
      <div className="login-page-wrapper">
        {/* {errorblock && (
          <div
            className={`popup ${errorClass}`}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
            }}
          >
            <div>{error}</div>
            <div>
              <button
                onClick={erroBlockHandel}
                className={`download ${errorClass}`}
              >
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        )} */}
        {errorblock && (
          <ModalError error={t(`${error}`)} errorClose={errorClose}></ModalError>
        )}
        <Navigation page={isLoginpage}></Navigation>

        <div id="layoutSidenav_content" className="login-layout-content">
          <main>
            <header className="login-page-shell">
              <div className="login-page-container">
                <section className="login-form-panel">
                  <div className="login-card">
                    <div className="login-card-header">
                      <div className="login-card-logo">
                        <img src="/images/new_logo.png" alt="OWCS" />
                      </div>
                      <h1 className="KhmerOSmuollighttext">
                        {t("fd9242b35808986c4f749114e90875ec")}
                      </h1>
                    </div>

                    <form className="login-form" onSubmit={loginHandel}>
                      <div className="login-field-group">
                        <label className="KhmerOSsiemreaptext login-label" htmlFor="loginId">
                          {t("8e233234a83a277872b8ce305dceb914")}{" "}
                          <span className="login-required">*</span>
                        </label>
                        <div className="login-input-wrap">
                          <FaIdCard className="login-input-icon" />
                          <input
                            className="KhmerOSsiemreaptext login-input"
                            id="loginId"
                            type="text"
                            inputMode="numeric"
                            placeholder={t("504c46e2c369d441b6eb6c581101fc85")}
                            value={loginId}
                            onChange={(e) => {
                              setLoginID(e.target.value);
                            }}
                            autoComplete="username"
                          />
                        </div>
                      </div>

                      <div className="login-field-group">
                        <label className="KhmerOSsiemreaptext login-label" htmlFor="loginPassword">
                          {t("dc647eb65e6711e155375218212b3964")}{" "}
                          <span className="login-required">*</span>
                        </label>
                        <div className="login-input-wrap">
                          <FaKey className="login-input-icon" />
                          <input
                            className="KhmerOSsiemreaptext login-input"
                            id="loginPassword"
                            type="password"
                            placeholder={t("d351d57d7bafd005cdaabd11a85da85d")}
                            value={password}
                            onChange={(e) => {
                              setPassword(e.target.value);
                            }}
                            autoComplete="current-password"
                          />
                        </div>
                      </div>

                      <div className="login-captcha-grid">
                        <div className="login-field-group">
                          <label className="KhmerOSsiemreaptext login-label" htmlFor="captchaDisplay">
                            {t("45d048c35e3cfd449dc0a1b503cd103a")}{" "}
                            <span className="login-required">*</span>
                          </label>
                          <div className="login-captcha-display">
                            <input
                              className="KhmerOSsiemreaptext login-input login-captcha-code"
                              id="captchaDisplay"
                              type="text"
                              value={styleCaptcha}
                              disabled
                              onCopy={(e) => {
                                e.preventDefault();
                                return false;
                              }}
                            />
                            <button
                              className="login-captcha-refresh"
                              type="button"
                              onClick={captchaReload}
                              aria-label="Refresh captcha"
                            >
                              <FaRedoAlt />
                            </button>
                          </div>
                        </div>

                        <div className="login-field-group">
                          <label
                            className="KhmerOSsiemreaptext login-label login-label-empty"
                            htmlFor="captchaInput"
                          ></label>
                          <input
                            className="KhmerOSsiemreaptext login-input"
                            id="captchaInput"
                            type="text"
                            inputMode="numeric"
                            placeholder={t("394fb72441549c3175d7784c3aa8a458")}
                            value={captcha}
                            autoComplete="off"
                            onChange={(e) => {
                              setCaptcha(e.target.value);
                            }}
                          />
                        </div>
                      </div>

                      <button
                        className="KhmerOSsiemreaptext login-submit-button"
                        type="submit"
                      >
                        <span>{t("fd9242b35808986c4f749114e90875ec")}</span>
                        <FaKey />
                      </button>

                      <div className="login-secondary-links">
                        <Link
                          className="KhmerOSsiemreaptext"
                          to={"/forgetPasswordHolder"}
                        >
                          <FaUnlockAlt />
                          <span>{t("6d909c2ed76c42670f090b269a478b7f")}</span>
                        </Link>
                        <Link
                          className="KhmerOSsiemreaptext"
                          to={"/registrationHolder"}
                        >
                          <FaUserPlus />
                          <span>{t("2fe4fe0a0ebea41ce43eb3dc3fce4ea3")}</span>
                        </Link>
                      </div>
                    </form>
                  </div>
                </section>
              </div>
            </header>
          </main>
        </div>

        <Footer></Footer>
        {isloading && (
          <div className="loderdiv">
            <ClipLoader
              color="hsla(203, 66%, 53%, 1)"
              size={80}
              cssOverride={override}
            />
          </div>
        )}
      </div>
    </>
  );
}

export default Login;

// to_convert
// Captcha does not match
// Invalid Credentials.
// This account has been blocked/
// Your account submission has been rejected
// Your account is currently pending approval.
// Please fill out all required fields
